import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card'
import { SkeletonRows } from '@/components/ui/skeleton'
import { useApplicationProspects } from '../../../../models/internalApplication'

function formatDateTime(dateStr: string): string {
  return new Date(dateStr).toLocaleString('en-US', {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
  })
}

export function ProspectsTab({ applicationId }: { applicationId: string }) {
  const { prospects, isLoading } = useApplicationProspects(applicationId)

  return (
    <Card className="mt-4">
      <CardHeader>
        <CardTitle>Prospects</CardTitle>
        <p className="text-muted-foreground text-sm">
          Contact info captured from the &quot;Get in touch&quot; form on the public results page.
        </p>
      </CardHeader>
      <CardContent>
        {isLoading ? (
          <SkeletonRows rows={3} />
        ) : prospects.length === 0 ? (
          <p className="text-muted-foreground text-sm">No prospects yet.</p>
        ) : (
          <div className="overflow-hidden rounded-md border">
            <table className="w-full text-sm">
              <thead className="bg-muted/40 text-muted-foreground text-xs font-semibold uppercase">
                <tr>
                  <th className="px-4 py-2 text-left">Submitted</th>
                  <th className="px-4 py-2 text-left">Email</th>
                  <th className="px-4 py-2 text-left">Mobile</th>
                </tr>
              </thead>
              <tbody className="divide-y">
                {prospects.map((p) => (
                  <tr key={p.id}>
                    <td className="text-muted-foreground px-4 py-2">{formatDateTime(p.dateCreated)}</td>
                    <td className="text-foreground px-4 py-2">{p.email || '-'}</td>
                    <td className="text-foreground px-4 py-2">{p.mobile || '-'}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </CardContent>
    </Card>
  )
}
